import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/build/repo/src/components/landing/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/opt/build/repo/src/components/landing/Navbar.tsx");
